// extracted by mini-css-extract-plugin
module.exports = {"pr4zyoo":"pr4zyoo","opened":"opened","py3dw1f":"py3dw1f","s1rfmxz9":"s1rfmxz9","ojjd2vj":"ojjd2vj","i8asosv":"i8asosv"};